<div
  class="flex items-start w-full rounded-lg bg-gray-100 p-2 shadow-sm"
>
  <div *ngIf="review?.featuredAsset?.imageUrl || review?.featuredAsset?.preview" class="shrink-0">
    <img
      class="w-12 h-12 mr-4 rounded-full object-cover shrink-0"
      [src]="review?.featuredAsset | assetPreview:'small':'webp'"
      alt="Reviewer avatar"
    />
  </div>
  <div class="flex-1">
    <p class="text-sm md:text-base font-semibold text-[#242424] mb-1">
      {{ review?.summary }}
    </p>
    <p
      class="text-sm text-[#242424] opacity-90 line-clamp-4 cursor-pointer hover:line-clamp-none relative"
      [innerHTML]="review?.body | safeHtml"
    ></p>
    <div class="border-t border-gray-300 my-2"></div>
    <div class="flex flex-col items-start text-left text-sm text-[#242424]">
      <span class="font-medium mb-1">{{ review?.authorName || 'Anonymous' }}</span>
      <vsf-product-review-indicator
        [inputScore]="review?.rating"
        [displayReviewNumbers]="false"
      ></vsf-product-review-indicator>
    </div>
  </div>
</div>
